import { useState, useEffect } from "react";
import { BUSINESS } from "../data";
import { Phone, Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Why Us", href: "#why-us" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#F7F5F0]/85 backdrop-blur-xl border-b border-[#D8D3C8]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className={`flex items-baseline gap-1 transition-colors ${scrolled ? "text-[#1A2118]" : "text-white"}`}
        >
          <span className="font-serif-display text-3xl leading-none tracking-tight">JMG</span>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold mb-1">Landscape</span>
        </a>

        <nav data-testid="nav-links" className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`text-sm font-medium tracking-wide transition-colors hover:opacity-70 ${
                scrolled ? "text-[#4A5447]" : "text-white/90"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-quote-btn"
            className="rounded-sm bg-[#1E3F20] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#2B5A2D] transition-colors"
          >
            Get a Quote
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className={`md:hidden ${scrolled ? "text-[#1A2118]" : "text-white"}`}
          aria-label="Menu"
        >
          {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#F7F5F0] border-t border-[#D8D3C8] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[#1A2118] text-base font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            className="flex items-center gap-2 text-[#1E3F20] font-semibold"
          >
            <Phone size={18} strokeWidth={1.5} /> {BUSINESS.phone}
          </a>
        </div>
      )}
    </header>
  );
};
